import Vue from 'vue'
import Vuex from 'vuex'
import Setting from './Setting/index'
import baseModule from "./modules/base.module";
import authModule from "./modules/auth.module";
import userModule from "./modules/user.module";
import allSettingModule from "./modules/settingAll.module";
import payPeriodModule from "./modules/payPeriod.module";
import salaryPackagingProviderModule from "./modules/salaryPackagingProvider.module";
import leaseTermModule from "./modules/leaseTerm.module";
import businessUsePercentageModule from "./modules/businessUsePercentage.module";
import vehicleConditionModule from "./modules/vehicleCondition.module";
import vehicleCategoryModule from "./modules/vehicleCategory.module";
import transmissionModule from "./modules/transmission.module";
import fuelTypeModule from "./modules/fuelType.module";
import dealerModule from "./modules/dealer.module";
import dealerManagerModule from './modules/dealerManager.module';
import australianResidencyStatusModule from "./modules/australianResidencyStatus.module";
import driversLicenceTypeModule from "./modules/driversLicenceType.module";
import employmentStatusModule from "./modules/employmentStatus.module";
import residentialStatusModule from "./modules/residentialStatus.module";
import stateModule from "./modules/state.module";
import visaTypeModule from "./modules/visaType.module";
import otherIncomeModule from "./modules/otherIncome.module";
import otherLoanModule from "./modules/otherLoan.module";
import documentTypeModule from "./modules/documentType.module";
import clientModule from './modules/client.module';
import quoteModule from './modules/quote.module';
import lookupValuesModule from './modules/lookupValues.module';
import taxTableModule from './modules/taxTable.module'
import formDownloadModule from './modules/formDownload.module';
import faqModule from './modules/faq.module';
import dashboardAdminModule from './modules/dashboardAdmin.module';
import dashboardBDMModule from './modules/dashboardBDM.module';
import dashboardDealerModule from './modules/dashboardDealer.module';
import dashboardRpModule from './modules/dashboardRp.module';
import reportModule from './modules/report.module';
import msgModule from './modules/msg.module';
import financierModule from './modules/financier.module';
import referralPartnerModule from './modules/referralPartner.module';
import leadsModule  from './modules/leads.module';
import carsModule from './modules/cars.module';
import carCategoryModule from './modules/carCategory.module';
import invoiceModule from './modules/invoice.module';
import maturingLeasModule from './modules/maturingLeas.module';
import employerModule from './modules/employer.module';
import emModule from './modules/em.module';
import designationModule from './modules/designation.module';
import emailTemplateModule from './modules/emailTemplate.module';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    Setting,
    baseModule,
    authModule,
    allSettingModule,
    userModule,
    payPeriodModule,
    salaryPackagingProviderModule,
    leaseTermModule,
    businessUsePercentageModule,
    vehicleConditionModule,
    vehicleCategoryModule,
    transmissionModule,
    fuelTypeModule,
    dealerModule,
    dealerManagerModule,
    australianResidencyStatusModule,
    driversLicenceTypeModule,
    employmentStatusModule,
    residentialStatusModule,
    stateModule,
    visaTypeModule,
    otherIncomeModule,
    otherLoanModule,
    documentTypeModule,
    clientModule,
    quoteModule,
    lookupValuesModule,
    taxTableModule,
    formDownloadModule,
    faqModule,
    dashboardAdminModule,
    dashboardBDMModule,
    dashboardDealerModule,
    dashboardRpModule,
    reportModule,
    msgModule,
    financierModule,
    referralPartnerModule,
    leadsModule,
    carsModule,
    carCategoryModule,
    invoiceModule,
    maturingLeasModule,
    employerModule,
    emModule,
    designationModule,
    emailTemplateModule,
  },
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  },
  strict: debug
})
